import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { UrlService } from '@core/services/url/url.service';

@Injectable({
    providedIn: 'root'
})
export class WorkflowsService {

    constructor(protected url: UrlService, protected http: HttpClient) {}

    deactivateWorkflow$(id: number, prefixUrl: string = "") {
        return this.http
        .delete(this.url.build(prefixUrl+"/workflows/" + id ));
    }

    activateWorkflow$(id: number, prefixUrl: string = "") {
        return this.http
        .put(this.url.build(prefixUrl+"/workflows/" + id ),
            {active: true}
        );
    }

    updateWorkflowName$(name: string,id: number, prefixUrl: string = "") {
        let wfData: any = {
            name: name
        };
        return this.http
        .put(this.url.build(prefixUrl+"/workflows/" + id ),
            wfData
        );
    }


    addWorkflow$(name: string, prefixUrl: string = "") {
        let options = {headers: new HttpHeaders({
            'Content-Type':  'application/json',
        })};
        let wfData: any = {
            name: name
        };
        return this.http.post(
            this.url.build(prefixUrl+"/workflows"),
            wfData,
            options
        );
    }

    // projects add workflows source.
    getWorkflows$(prefixUrl: string = "") {
        return this.http
        .get(this.url.build(prefixUrl+"/workflows"));
    }


}
